const voices = [
  {
    name: "T.S 様",
    area: "京都市北区 / 40代女性",
    service: "遺品整理",
    text: "母の遺品整理をお願いしました。写真や手紙の仕分けまで一つひとつ確認してくださり、涙が出るほど丁寧でした。合同供養までお任せできて本当に助かりました。",
    stars: 5,
  },
  {
    name: "K.N 様",
    area: "京都市山科区 / 30代男性",
    service: "不用品回収",
    text: "急な引越しで当日夜にお願いしたのに、すぐ来てくれました。追加料金なしで見積り通り。京都 不用品回収でここまで早いのは初めてでした。",
    stars: 5,
  },
  {
    name: "H不動産様",
    area: "京都市下京区 / 法人",
    service: "残置物撤去",
    text: "退去後の物件が続くたびに依頼しています。写真報告書と請求書対応が助かる。管理会社としては本当に頼れる存在です。",
    stars: 5,
  },
  {
    name: "M.Y 様",
    area: "京都府宇治市 / 60代女性",
    service: "ゴミ屋敷清掃",
    text: "何年も片づけられず悩んでいました。プライバシーを守っていただき、近隣にも配慮した搬出で本当に助かりました。部屋も消臭までしていただき見違えました。",
    stars: 5,
  },
  {
    name: "S工務店様",
    area: "京都府亀岡市 / 法人",
    service: "産廃回収",
    text: "小規模な解体現場からの産廃回収でお世話になっています。マニフェスト対応と柔軟な回収スケジュールで、現場責任者としてとても助かっています。",
    stars: 5,
  },
  {
    name: "A.K 様",
    area: "京都市西京区 / 50代男性",
    service: "遺品整理",
    text: "父が亡くなり、遠方から手配する必要がありました。鍵預かりから最後の確認まで、全部LINEでやり取りできて助かりました。ありがとうございました。",
    stars: 5,
  },
];

function Stars({ n }: { n: number }) {
  return (
    <div className="flex items-center gap-0.5 text-primary-500">
      {[...Array(5)].map((_, i) => (
        <span key={i} className="w-4 h-4 flex items-center justify-center">
          <i className={`${i < n ? "ri-star-fill" : "ri-star-line"} text-sm`}></i>
        </span>
      ))}
    </div>
  );
}

export default function Voices() {
  return (
    <section id="voices" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            CUSTOMER VOICES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            お客様の声<span className="text-secondary-500 text-xl md:text-2xl align-middle ml-3">（掲載例）</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            以下は実際のお客様アンケートではなく、サービスのイメージをお伝えするための掲載例です。
          </p>
        </div>

        <div className="mb-10 flex items-start gap-3 p-4 rounded-md bg-secondary-100 border border-secondary-200 text-secondary-900 text-xs md:text-sm">
          <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-2-line"></i>
          </span>
          <p>
            ※掲載しているコメント・お名前・地域はすべて<strong>サービス内容を伝えるための掲載例</strong>であり、実在のお客様のレビューではありません。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {voices.map((v) => (
            <div
              key={v.name}
              className="p-7 rounded-lg bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <Stars n={v.stars} />
                <span className="px-2 py-1 rounded-md bg-secondary-500 text-background-50 text-[10px] font-bold tracking-wider">
                  掲載例
                </span>
              </div>
              <p className="text-foreground-800 text-sm leading-relaxed mb-6 flex-1">
                「{v.text}」
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold">
                  {v.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <p className="font-bold text-foreground-950 text-sm">{v.name}</p>
                  <p className="text-foreground-500 text-xs">{v.area}</p>
                </div>
                <span className="px-2 py-1 rounded-full bg-accent-100 text-accent-800 text-[10px] font-bold whitespace-nowrap">
                  {v.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}